<script lang="ts">
  import { sharedAssets } from '../assets/asset-store';
  import { atlasSignal } from '../assets/atlas-signal.svelte';

  interface Props {
    team: number;
    shipId: number;
    size: number;
    class?: string;
  }

  const { team, shipId, size, class: className = '' }: Props = $props();

  const css = $derived.by(() => {
    void atlasSignal.generation;
    return sharedAssets.tintedSpriteCss('ship', team, shipId, size);
  });
</script>

{#if css !== null}
  <span
    class={className}
    style:background-image="url({css.url})"
    style:background-size={css.backgroundSize}
    style:background-position={css.backgroundPosition}
    style:width="{css.width}px"
    style:height="{css.height}px"
    style:display="inline-block"
  ></span>
{/if}
